<template>
    <div class="border rounded-md border-branding-simple-grey p-4">
        <div class="text-branding-cool-grey text-base leading-8 mb-4">{{ $t('settings.credit.automatic_buy') }}</div>

        <div class="grid grid-cols-[auto,1fr] grid-rows-2 items-center gap-4">
            <SmoothToggleSwitch
                :model-value="automatedPurchaseValue"
                @update:model-value="toggleAutomaticBuy"
            />
            <div class="font-semibold text-branding-mid-grey text-sm">
                {{ $t('settings.credit.activate_automatic_buy') }}
            </div>
            <div class="col-start-2 text-sm text-branding-mid-grey">
                {{ $t('settings.credit.automatic_authorization') }}
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    const props = defineProps<{
        automatedPurchase: boolean;
    }>();

    const automatedPurchaseValue = ref(props.automatedPurchase);
    useState('hasAutomatedCreditPurchase', () => automatedPurchaseValue.value);

    const form = useForm<{
        automated_credits_purchase: SettingField;
    }>({
        automated_credits_purchase: {
            module: 'tenant',
            key: 'automated_credits_purchase',
            value: automatedPurchaseValue,
        },
    });

    const toggleAutomaticBuy = async () => {
        automatedPurchaseValue.value = !automatedPurchaseValue.value;
        await useSaveSettings(form);
        if (form.errors.any()) {
            automatedPurchaseValue.value = !automatedPurchaseValue.value;
        }
    };
</script>
